import { defineComponent as _defineComponent } from 'vue'
import BCXUserBannerSimple from '@/components/molecules/BCXUserBannerSimple.vue';
import { PropType } from 'vue';
import useFormattedDateTime from '@/mixins/useFormattedDateTime';
import { Contract } from '@/models/Contracts';
import useUser from '@/mixins/useUser';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoicesActionContractDetails',
  props: {
  contract: {
    type: Object as PropType<Contract>,
    required: true
  }
},
  setup(__props) {



const { getFormattedDate } = useFormattedDateTime();
const { tUserFallback: t } = useUser('self');


return { __sfc: true,getFormattedDate, t, BCXUserBannerSimple }
}

})